import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

export const useAuthApi = () => {
  const navigate = useNavigate();
  const apiClient = axios.create({
    baseURL: "https://api365.geoexpress.ge/api",
  });

  apiClient.interceptors.response.use(
    (response) => {
      if (response.data.message === "User not Confirmed") {
        navigate("/auth-confirmation");
      }
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        Cookies.remove("Authorization");
        navigate("/auth-signin");
      }
      return Promise.reject(error);
    }
  );

  return apiClient;
};

// const authApi = axios.create({
//   baseURL: "https://api365.geoexpress.ge/api",
//   headers: {
//     "Content-type": "application/json",
//   },
//   timeout: 5000,
// });

// authApi.interceptors.response.use(
//   (response) => {
//     if (response.data.message === "User not Confirmed") {
//       const navigate = useNavigate();
//       navigate("/auth-confirmation");
//     }
//     return response;
//   },
//   (error) => {
//     if (error.response.status === 401) {
//       Cookies.remove("Authorization");
//       const navigate = useNavigate();
//       navigate("/auth-signin");
//     }
//     return Promise.reject(error);
//   }
// );

// export default authApi;
